var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{style:(_vm.style)},[_c('v-text-field',_vm._b({staticClass:"mx-2",attrs:{"hide-details":""},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-text-field',_vm.attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }